import React, { Component } from 'react';
import { Table, Tabs } from 'antd';
import jquery from 'jquery';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';
import '../style/home.less';

const { TabPane } = Tabs;
const monthFormat = 'YYYY-MM';

class MainContent extends Component {
    state = {
        panes: [],
        activeKey: '',
        investigations: [],
        invLoading: false,
    }

    componentDidMount() {
        const { startDate, endDate } = this.props;
        this.changePanes(startDate, endDate);
    }

    componentWillReceiveProps(nextProps) {
        const { startDate, endDate } = this.props;
        if (startDate !== nextProps.startDate || endDate !== nextProps.endDate) {
            this.changePanes(nextProps.startDate, nextProps.endDate);
        }
    }

    changePanes = (startDate, endDate) => {
        const panes = [];
        let newValue = moment(startDate);
        const endValue = moment(endDate);
        const activeKey = newValue.format(monthFormat);
        while (newValue.valueOf() <= endValue.valueOf()) {
            panes.push({
                title: newValue.format(monthFormat),
                content: null,
            });
            newValue = newValue.add(1, 'M');
        }
        this.setState({
            panes,
            activeKey,
        }, () => {
            this.queryPerformancePmChargeInvestigation();
        })
    }

    getRender = (text, record, current) => {
        const obj = {
            children: text,
            props: {},
        };
        if (record[`rowSpan${current}`]) {
            obj.props.rowSpan = record[`rowSpan${current}`];
        } else {
            obj.props.rowSpan = 0;
        }
        if (record.itemName1 == '合计') {
            if (current == 1) {
                obj.props.colSpan = 3;
                obj.children = <strong>{text}</strong>;
            } else {
                obj.props.colSpan = 0;
            }
        }
        return obj;
    }

    getMainColumns = () => ([
        {
            title: '一级考核项',
            dataIndex: 'itemName1',
            width: 280,
            render: (text, record) => this.getRender(text, record, 1), 
        }, {
            title: '二级考核项',
            dataIndex: 'itemName2',
            width: 280,
            render: (text, record) => this.getRender(text, record, 2), 
        }, {
            title: '三级考核项',
            dataIndex: 'itemName3',
            width: 290,
            render: (text, record) => {
                const obj = {
                    children: text,
                    props: {},
                };
                if (record.itemName1 == '合计') {
                    obj.props.colSpan = 0;
                }
                return obj;
            }
        }, {
            title: '得分',
            dataIndex: 'score',
            width: 280,
            render: (text, record) => {
                if (record.itemName1 == '合计') {
                    return <strong>{text}</strong>;
                }
                return text;
            }
        }
    ])

    getMainDataSource = () => {
        const { treeData } = this.props;
        const list = [...treeData];
        let dataSource = [];

        list.forEach(item => {
            if (item.childList) {
                item.rowSpan = this.handleList(item.childList);
            }
        });

        const obj = { key: 1 };

        this.loopData(list, dataSource, 0, {}, obj);
        
        // 计算总分
        let totalScore = 0;
        dataSource.forEach(item => {
            totalScore += Number(item.score);
        });
        dataSource.push({
            index: dataSource.length + 1,
            itemName1: '合计',
            rowSpan1: 1,
            score: totalScore.toFixed(2),
        });

        return dataSource;
    }

    handleList = (list) => {
        let count = 0;
        for (let i = 0, len = list.length; i < len; i++) {
            if (list[i].childList && list[i].childList.length) {
                list[i].rowSpan = this.handleList(list[i].childList);
                count += list[i].rowSpan;
            } else {
                count += 1;
                list[i].rowSpan = 1;
            }
        }
        return count;
    }

    loopData = (list, dataSource, current, params, obj) => {
        current++;
        list.forEach((item, index) => {
            if (item.childList && item.childList.length) {
                const { rowSpan, itemName } = item;
                const newParams = {
                    ...params,
                    [`rowSpan${current}`]: rowSpan,
                    [`itemName${current}`]: itemName,
                };
                if (current == 2) {
                    index && (newParams[`rowSpan1`] = 0);
                }
                this.loopData(item.childList, dataSource, current, newParams, obj);
            } else {
                const { rowSpan, itemName, score } = item;
                const newParams = {
                    index: obj.key++,
                    ...params,
                    score,
                    [`itemName${current}`]: itemName,
                };
                if (current == 2) {
                    newParams[`rowSpan${current}`] = rowSpan;
                    newParams[`itemName${current + 1}`] = '-';
                }
                if (index) {
                    newParams[`rowSpan1`] = 0;
                    current == 3 && (newParams[`rowSpan2`] = 0);
                }
                dataSource.push(newParams);
            }
        });
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey }, () => {
            this.queryPerformancePmChargeInvestigation()
        })
    }

    queryPerformancePmChargeInvestigation = () => {
        const { userId } = this.props;
        const { activeKey } = this.state;
        this.setState({ invLoading: true });
        const options = {
            method: 'POST',
            url: API_URL.home.queryPerformancePmChargeInvestigation,
            data: {
                userId,
                date: activeKey,
            },
            dataType: 'json',
            doneResult: res => {
                const { investigations } = res;
                this.setState({
                    invLoading: false,
                    investigations,
                }, () => {
                    const { panes } = this.state;
                    panes.forEach(item => {
                        if (item.title == activeKey) {
                            item.content = this.getInvTable();
                        } else {
                            item.content = null;
                        }
                    });
                    this.setState({ panes });
                })
            },
            errorResult: () => {
                this.setState({ invLoading: false });
            }
        }
        $.sendRequest(options)
    }

    getInvTable = () => {
        const { invLoading } = this.state;
        return (
            <Table
                bordered
                loading={invLoading}
                scroll={{x: 1855, y: 300}}
                pagination={false}
                className="pmPerformanceDetail-inv"
                style={{borderBottom: '1px solid #d1d1d1'}}
                columns={this.getInvColumns()}
                dataSource={this.getInvDataSource()}
                rowKey={record => record.index}
            />
        )
    }

    getInvRender = (text) => {
        return (text || text === 0) ? text : '-';
    }

    getInvColumns = () => ([
        {
            title: '序号',
            dataIndex: 'index',
            width: 60,
            fixed: 'left',
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            width: 120,
            fixed: 'left',
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            width: 100,
            fixed: 'left',
        }, {
            title: '项目阶段',
            dataIndex: 'stageNames',
            width: 80,
        }, {
            title: '项目分类',
            dataIndex: 'investigationAreaName',
            width: 80,
        }, {
            title: '津石计划负责中心数量',
            dataIndex: 'typeSiteAmount',
            width: 80,
            render: this.getInvRender
        }, {
            title: '津石计划筛选数量',
            dataIndex: 'typeFilterAmount',
            width: 70,
            render: this.getInvRender
        }, {
            title: '津石计划随机(入组)数量',
            dataIndex: 'typeRandomAmount',
            width: 90,
            render: this.getInvRender
        }, {
            title: '新启动site数量',
            dataIndex: 'newSiteNum',
            width: 70,
            render: this.getInvRender
        }, {
            title: '新筛选患者数量',
            dataIndex: 'newFilterNum',
            width: 70,
            render: this.getInvRender
        }, {
            title: '新入组患者数量',
            dataIndex: 'newRandomNum',
            width: 70,
            render: this.getInvRender
        }, {
            title: '本月在组病人数',
            dataIndex: 'newPatientInProgressNum',
            width: 70,
            render: this.getInvRender
        }, {
            title: '当月完成的访视数',
            dataIndex: 'newVisitNum',
            width: 70,
            render: this.getInvRender
        }, {
            title: '累计已启动中心数量',
            dataIndex: 'totalSiteNum',
            width: 80,
            render: this.getInvRender
        }, {
            title: '累计关中心数量',
            dataIndex: 'totalCloseSiteNum',
            width: 70,
            render: this.getInvRender
        }, {
            title: '合同计划中心数量',
            dataIndex: 'contractSitePlanAmount',
            width: 70,
            render: this.getInvRender
        }, {
            title: '累计已入组病例数',
            dataIndex: 'totalRandomNum',
            width: 75,
            render: this.getInvRender
        }, {
            title: '合同计划随机(入组)数量',
            dataIndex: 'contractRandomPlanAmount',
            width: 90,
            render: this.getInvRender
        }, {
            title: '累计已消耗FTE',
            dataIndex: 'cumulativeConsumptionFte',
            width: 70,
            render: this.getInvRender
        }, {
            title: '合同FTE',
            dataIndex: 'contractFte',
            width: 80,
            render: this.getInvRender
        }, {
            title: '合同额含税(元)',
            dataIndex: 'jdeContractAmount',
            width: 105,
            render: text => (text || text === 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-',
        }, {
            title: '已回款金额(元)',
            dataIndex: 'moneyBackAmount',
            width: 105,
            render: text => (text || text === 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-',
        }, {
            title: '回款比例',
            dataIndex: 'moneyBackProportion',
            width: 80,
            render: this.getInvRender
        }
    ])

    getInvDataSource = () => {
        const { investigations = [] } = this.state;
        const dataSource = investigations.map((item, index) => {
            return {
                index: index + 1,
                ...item,
            }
        });
        // 处理表头分组没数据时，不显示滚动条的bug
        setTimeout(() => {
            if (!dataSource.length) {
                jquery('.pmPerformanceDetail-inv .ant-table-scroll .ant-table-header').css('margin-bottom', 0);
            } else {
                jquery('.pmPerformanceDetail-inv .ant-table-scroll .ant-table-header').css('margin-bottom', -16);
            }
        }, 100);
        return dataSource;
    }

    render() {
        const { loading } = this.props;
        const { panes, activeKey } = this.state;
        return (
            <div className="tab-performance">
                <div style={{ lineHeight: '48px' }}>1.主要业绩分明细</div>
                <Table
                    bordered
                    loading={loading}
                    scroll={{x: 1130}}
                    pagination={false}
                    columns={this.getMainColumns()}
                    dataSource={this.getMainDataSource()}
                    rowKey={record => record.index}
                />
                <div style={{ lineHeight: '48px' }}>2.PM负责的进行中项目</div>
                {
                    panes.length > 1 ?
                        <Tabs type="card" animated={true} activeKey={activeKey} onChange={this.handleTabsChange}>
                            {
                                panes.map(pane => <TabPane tab={pane.title} key={pane.title}>{pane.content}</TabPane>)
                            }
                        </Tabs>
                    :
                        this.getInvTable()
                }
            </div>
        )
    }
}

export default MainContent;


// WEBPACK FOOTER //
// ./src/components/home/pmPerformanceDetail/MainContent.js